// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m915vq{overflow-y:hidden}
._1bah1h6o{justify-content:center}
._1e0c116y{display:inline-flex}
._1reo15vq{overflow-x:hidden}
._4cvr1h6o{align-items:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/media-svg/dist/esm/media-svg/loading-compiled.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,sBAAsB;AACjC,WAAW,mBAAmB;AAC9B,WAAW,iBAAiB;AAC5B,WAAW,kBAAkB","sourcesContent":["._18m915vq{overflow-y:hidden}\n._1bah1h6o{justify-content:center}\n._1e0c116y{display:inline-flex}\n._1reo15vq{overflow-x:hidden}\n._4cvr1h6o{align-items:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
